// The director's moves (T230): a proposal on the rail names a move, and the
// bench it opens marks the control that makes it with data-move="<id>". When
// the bench renders, the control is scrolled into view, lit for a moment and
// given focus — the director points, the creator presses. Nothing runs by
// itself.

export const LIT_MS = 2400;

export function moveSelector(id: string): string {
  return `[data-move="${id.replace(/["\\]/g, '')}"]`;
}

/** Find the move's control once the bench has drawn it (up to ~2 s), then point at it. */
export function focusMove(id: string, doc: Document = document, tries = 20): void {
  const el = doc.querySelector<HTMLElement>(moveSelector(id));
  if (!el) { if (tries > 0) setTimeout(() => focusMove(id, doc, tries - 1), 100); return; }
  el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  el.classList.add('move-lit');
  setTimeout(() => el.classList.remove('move-lit'), LIT_MS);
  const focusable = el.matches('button, input, select, textarea, a[href]') ? el : el.querySelector<HTMLElement>('button, input, select, textarea, a[href]');
  focusable?.focus({ preventScroll: true });
}
